import { useVacationBalanceQuery } from './data';
import { useAuth } from '@/contexts/AuthContext';

export interface UseVacationModuleAccessResult {
    canSeeModule: boolean;
    isLoading: boolean;
}

export function useVacationModuleAccess(): UseVacationModuleAccessResult {
    const { user } = useAuth();
    const { balance, isLoading } = useVacationBalanceQuery(user?.collaboratorId);

    const canSeeModule = !user?.collaboratorId || balance?.ineligibilityReason !== 'ContractType';

    return {
        canSeeModule,
        isLoading,
    };
}
